/**
 * DASHBOARD-RESULTS-TOPICS-SKELETON.WIDGET
 * Skeleton de la rosace : réutilise directement dashboard-results-topics-animated.widget.tsx
 * en mode `isSkeleton` (mêmes pétales, même animation d'entrée, juste grisées + pulsées)
 * plutôt qu'une approximation SVG séparée — garantit un rendu identique à la vraie rosace.
 */
import DashboardResultsTopicsAnimatedWidget from "../dashboard-results-topics-animated.widget"

export default function DashboardResultsTopicsSkeletonWidget() {
  return <DashboardResultsTopicsAnimatedWidget currentTopics={[]} note={0} isSkeleton />
}
